import { render, staticRenderFns } from "./EventCollectionPlan.vue?vue&type=template&id=065fae2e&scoped=true&"
import script from "./EventCollectionPlan.script.js?vue&type=script&lang=js&"
export * from "./EventCollectionPlan.script.js?vue&type=script&lang=js&"
import style0 from "../DataCollection.scss?vue&type=style&index=0&id=065fae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fae2e",
  null
  
)

export default component.exports